import moment from 'moment';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { CONSTANTS, STRINGS } from 'src/commons';
import CustomTable from 'src/components/Table';

const ExpiredMemberships = ({ expired_memberships }) => {
  const navigate = useNavigate();
  const [page, setPage] = useState(0);

  const data = expired_memberships?.map((membership) => {
    const tempMembership = {
      ...membership,
      expiry_date: moment(membership?.expiry_date).format('DD-mm-yyyy')
    };
    return tempMembership;
  });

  const onClickRow = (item) => {
    navigate(CONSTANTS.ROUTES.PRIVATE_ROUTES.EDIT_MEMBER + '/' + item._id);
  };

  const handlePageChange = (_, newPage) => {
    setPage(newPage);
  };

  return (
    <CustomTable
      data={data}
      dataKeysSequence={[
        'full_name',
        'email',
        'phone',
        'invoice_date',
        'expiry_date'
      ]}
      headers={['Name', 'Email', 'Phone', 'Invoice Date', 'Expiry Date']}
      handlePageChange={handlePageChange}
      page={page}
      onClickRow={onClickRow}
      NO_DATA_MESSAGE={STRINGS.NO_NOTIFICATIONS_FOUND}
    />
  );
};

export default ExpiredMemberships;
